import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  NgbDateStruct,
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit {
  startDate: NgbDate | any;
  endDate: NgbDate | any;
  hoveredDate: NgbDate | null = null;

  @Input() startDateValue: any;
  @Input() endDateValue: any;
  @Output() dateEmitter = new EventEmitter();

  constructor(
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter
  ) {}

  ngOnInit() {
    console.log(this.startDateValue, this.endDateValue);
    if (this.startDateValue) {
      this.startDate = this.convertStringDateToCalenderDate(
        this.startDateValue
      );
    }
    if (this.endDateValue) {
      this.endDate = this.convertStringDateToCalenderDate(this.endDateValue);
    }
  }

  onDateSelection(date: NgbDate, datepickerReference: any) {
    if (!this.startDate && !this.endDate) {
      this.startDate = date;
    } else if (
      this.startDate &&
      !this.endDate &&
      date &&
      date.after(this.startDate)
    ) {
      this.endDate = date;
    } else {
      this.endDate = null;
      this.startDate = date;
    }
    console.log(this.startDate, this.endDate);
    if (this.startDate && this.endDate) {
      this.dateEmitter.emit({
        startDate: this.convertCalenderDateToString(this.startDate),
        endDate: this.convertCalenderDateToString(this.endDate),
      });
      datepickerReference.close();
    }
  }

  selectToday(datepicker: any, type: 'start' | 'end') {
    const today = this.calendar.getToday();

    if (type === 'start') {
      this.startDate = today;
    } else if (type === 'end') {
      this.endDate = today;
    }

    this.dateEmitter.emit({
      startDate: this.convertCalenderDateToString(this.startDate),
      endDate: this.convertCalenderDateToString(this.endDate),
    });

    datepicker.close();
  }

  // for custom date selection
  isHovered(date: NgbDate) {
    return (
      this.startDate &&
      !this.endDate &&
      this.hoveredDate &&
      date.after(this.startDate) &&
      date.before(this.hoveredDate)
    );
  }

  // for custom date selection
  isInside(date: NgbDate) {
    return (
      this.endDate && date.after(this.startDate) && date.before(this.endDate)
    );
  }

  // for custom date selection
  isRange(date: NgbDate) {
    return (
      date.equals(this.startDate) ||
      (this.endDate && date.equals(this.endDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  // for custom date selection
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    console.log('validateInput', currentValue, input);
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  convertStringDateToCalenderDate(date: string) {
    const dateArray = date.split('-');
    return new NgbDate(
      parseInt(dateArray[0]),
      parseInt(dateArray[1]),
      parseInt(dateArray[2])
    );
  }

  convertCalenderDateToString(date: NgbDate) {
    return `${date.year}-${date.month}-${date.day}`;
  }
}
